new Vue({
    el:'.maglinkActive',
    data(){
        return{
            // 加载完成
            loadFlag:false,
            // 发送验证码标识
            sendFlag:false,
            loginFlag:false,
            verifyFlag:false,
            redeemFlag:false,
            popup:false,
            pointsPopup:false,
            loginPopup:false,
            qrCodePopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            user:{
                name:'',
                email:'',
                code:''
            },
            verify_code:'',
            submitFlag:false,
            popup1:false,
            select_flag1:0,
            pointsLog:[],
            prizeNum:[{num:200},{num:50},{num:50}],
            prizeIndex:-1,
            emailStr:'',
        }
    },
    methods:{
        // 功能类------------------------------------------------
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            if(this.sendFlag){
                showMessage('Sent, please try again in one minute.','success')
                setTimeout(() => {
                    this.sendFlag = false
                    this.sendText = 'Send code'
                }, 1000*60);
                return;
            }
            this.sendText = 'Has sent'
            this.sendFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/trifusion/M_sendEmail',params);
            if(res.data.status == 200){
                this.isSend = true
                showMessage('Email has been sent, please check.','success')
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        async loginActivity(){
            if(!this.isSend){
                showMessage('Please send the email verification code first','error')
                return;
            } 
            if(!this.user.name || !this.user.email || !this.user.code){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            //避免重复提交 
            if(this.loginFlag) return;
            this.loginFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/trifusion/M_loginActivity',params);
            if(res.data.status == 200){
                this.setCookie('_maglink_active_',res.data.data,90)
                this.user.token = res.data.data
                showMessage('Registration successful! ','success')
                this.popup = this.loginPopup = false
                this.getInfo()
            }else{
                this.loginFlag = false
                let errorMessages = {
                    201: 'Email verification code error',
                    202: 'Username already exists',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        async verifyCode(){
            if(!this.checkLogin()) return;
            if(this.verify_code == ''){
                showMessage('Ops, please fill in the anti-counterfeiting code first.','error');
                return;
            }
            //避免重复提交 
            if(this.verifyFlag) return;
            this.verifyFlag = true
            showMessage("Verification in progress...",'success')
            let params=new URLSearchParams();
            params.append('info',JSON.stringify({verify_code:this.verify_code}));
            let res = await axios.post('https://service.oxvatech.cn/trifusion/verifyCode',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                this.user.points += 10;
                this.user.points_all += 10;
                showMessage("Verification passed, points awarded.",'success')
            }else{
                this.verifyFlag = false
                let errorMessages = {
                    201: 'Anti-counterfeiting code does not exist.',
                    202: 'The anti-counterfeiting code has been verified.',
                    203: 'The anti-counterfeiting code has been verified multiple times.',
                    500:' Server error, please contact customer service.',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        async redeemPrize(id){
            if(!this.checkLogin()) return;
            this.prizeIndex = id
            var numArr = [20,30,40]
            if(this.user.points < numArr[id]){
                showMessage('Ops, Not enough points.','error')
                return;
            }
            if(this.prizeNum[id].num<1){
                return showMessage('Ops, Not Available.','error')
            }
            //如果是第三个奖品 到谷歌表单
            if(id == 0 || id == 1){
                showMessage('Redemption successful, we will contact you shortly.','success')
            }
            if(id == 2){
                showMessage('Redemption successful.','success')
                setTimeout(() => {
                    window.open('https://docs.google.com/forms/d/1seRNbsorGbQlmq6jVnM33CagFrEE4DLZ7pNagwAHLto/viewform?edit_requested=true','_blank')
                }, 1000);
            }

            //避免重复提交 
            if(this.redeemFlag) return;
            this.redeemFlag = true

            let params=new URLSearchParams();
            params.append('info',JSON.stringify({index:id}));
            let res = await axios.post('https://service.oxvatech.cn/trifusion/redeemPrize',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                this.redeemFlag = false
                this.getInfo()
                this.getPrizeNum()
            }else{
                this.redeemFlag = false
                let errorMessages = {
                    201: 'Ops, Not enough points.',
                    500:' Server error, please contact customer service.',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        async getInfo(){
            let res = await axios.post('https://service.oxvatech.cn/trifusion/M_getInfo', {}, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                if(res.data.data.arr1.length>0){
                    this.isLogin = true
                    this.user = res.data.data.arr1[0]
                    //积分记录
                    this.pointsLog = res.data.data.arr2
                    
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            } 
        },
        async getPrizeNum(){
            let res = await axios.get('https://service.oxvatech.cn/trifusion/M_getPrizeNum')
            if(res.status == 200){
                this.prizeNum = res.data.data
            }
        },
        // 控件类-------------------------------------------------
        showPopup(type){
            if(!this.checkLogin()) return;
            this.popup = this[type] = true;
        },
        checkLogin(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true;
                return false;
            }
            return true;
            // showMessage('The event has ended, thank you for your participation','success');
            // return false
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        // 工具类-------------------------------------------------
        formatISOToDateTime(isoString) {
            var date = new Date(isoString);
          
            // 转为北京时间（+8小时）
            date.setHours(date.getHours());
          
            var pad = (n) => n.toString().padStart(2, '0');
            var year = date.getFullYear();
            var month = pad(date.getMonth() + 1);
            var day = pad(date.getDate());
            var hours = pad(date.getHours());
            var minutes = pad(date.getMinutes());
            var seconds = pad(date.getSeconds());
          
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        // 扫描二维码识别数字
        qrCode(){
            var that = this
            this.popup = this.qrCodePopup = true
            setTimeout(() => {
                let html5QrCode = new Html5Qrcode("qr-reader");
                html5QrCode.start(
                    { facingMode: "environment" }, // 后置摄像头
                    {
                        fps: 10,
                        qrbox: 250,
                    },
                    (decodedText) => {
                        // 停止扫描
                        html5QrCode.stop().then(() => {
                        });

                        // 提取数字
                        const numbers = decodedText.match(/\d+/g);
                        that.popup = that.qrCodePopup = false
                        that.verify_code = numbers.join(", ")
                    }
                ).catch(err => {
                    showMessage('Camera access failed', 'error');
                });
            }, 300);
        },
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                    return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        }
    },
    created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        if(this.getCookie('_maglink_active_')){
            this.isLogin = true
            this.user.token = this.getCookie('_maglink_active_')
            this.getInfo()
        }
        this.getPrizeNum()
    },
    mounted(){
        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                    //toggleActions:'play none none reverse',
                }
            })
        }
        
        var wFlag=window.innerWidth>750
        
        showUp('.box2_title')
        if(wFlag){
            ScrollTrigger.create({
                trigger:'.box2',
                start:'top center',
                end:'+=0%',
                toggleActions:'play none none reverse',
                // markers:true,
                animation:gsap.timeline()
                    .from('.box2_item',{opacity:0,y:'2rem',stagger:0.2})
            })
        }
        
        showUp('.box3_title')
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top center',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box3_item',{y:'2rem',opacity:0,stagger:0.2})
        })
    }
})